import axios from 'axios';
import { APP_SETTINGS } from "../../config";

export function getSuggestions() {
    return axios.get(APP_SETTINGS.API_PATH.SUGGESTIONS.getSuggestions);
}

export function makeSuggestion(data) {
    return axios.post(APP_SETTINGS.API_PATH.SUGGESTIONS.addSuggestion, data);
}